import { Button, ShopCartIcon, styled, Typography } from 'opensolar-ui'
import { useTranslate } from 'ra-core'

const StyledButton = styled(Button)<{ disabled: boolean }>(({ disabled, theme }) => ({
  background: disabled ? `${theme.palette.blue[400]} !important` : `${theme.palette.blue[800]} !important`,
  borderRadius: '6px',
  fontSize: '15px',
  width: '100%',
  padding: '0 10px',
  minHeight: '40px',
  justifyContent: 'center',
  color: `${theme.palette.neutralGrey[100]} !important`,
  '&:hover': {
    border: 'none',
    background: theme.palette.blue[800],
    color: theme.palette.neutralGrey[100],
  },
  '& .OSUI-Typography-root': {
    color: `${theme.palette.neutralGrey[100]} !important`,
  },
}))

export const AddToCartButton = ({ onClick, disabled }: { onClick: (event) => void; disabled: boolean }) => {
  const translate = useTranslate()

  return (
    <StyledButton fullWidth disabled={disabled} startIcon={<ShopCartIcon size={20} />} onClick={onClick}>
      <Typography textVariant="body1SemiBold">{translate('Add to cart')}</Typography>
    </StyledButton>
  )
}
